import React, { useState } from 'react';
import { theme } from '../../theme';

// Inline action bar that fades in when the parent <tr class="hov-row"> is
// hovered. Swipe pattern — keeps tables visually clean while still giving
// quick access to row-level actions.
//
// Caller wraps each action as: { key, label, icon, color, onClick, title }
// `compact=true` shows icons only (recommended for >3 actions).
//
// Usage:
//   <tr className="hov-row">…<td><HoverActions actions={[...]} /></td></tr>
//
// You also need the global CSS rule (added once at app root):
//   .hov-row .hov-actions { opacity: 0; transition: opacity .12s; }
//   .hov-row:hover .hov-actions { opacity: 1; }
export default function HoverActions({ actions = [], compact = false, alwaysVisible = false }) {
  const [openMenu, setOpenMenu] = useState(false);

  // Show first 3 directly, fold the rest into a ⋮ menu.
  const inline = actions.slice(0, 3);
  const overflow = actions.slice(3);

  return (
    <div
      className={alwaysVisible ? '' : 'hov-actions'}
      style={{ display: 'inline-flex', alignItems: 'center', gap: '4px', opacity: alwaysVisible ? 1 : undefined }}
    >
      {inline.map((a) => (
        <button
          key={a.key}
          onClick={(e) => { e.stopPropagation(); a.onClick && a.onClick(); }}
          title={a.title || a.label}
          style={{
            display: 'inline-flex', alignItems: 'center', gap: '4px',
            padding: compact ? '5px 7px' : '5px 10px',
            border: 'none', borderRadius: '6px', cursor: 'pointer',
            backgroundColor: a.color || '#f1f5f9',
            color: a.textColor || theme.navy,
            fontSize: '0.74rem', fontWeight: '600',
            transition: 'transform 0.1s',
          }}
          onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-1px)'; }}
          onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; }}
        >
          {a.icon}
          {!compact && a.label}
        </button>
      ))}
      {overflow.length > 0 && (
        <div style={{ position: 'relative' }}>
          <button
            onClick={(e) => { e.stopPropagation(); setOpenMenu((v) => !v); }}
            title="More"
            style={{
              padding: '5px 8px', border: 'none', borderRadius: '6px', cursor: 'pointer',
              backgroundColor: '#f1f5f9', color: theme.navy, fontWeight: '700',
            }}
          >⋮</button>
          {openMenu && (
            <>
              <div onClick={() => setOpenMenu(false)} style={{ position: 'fixed', inset: 0, zIndex: 100 }}/>
              <div style={{
                position: 'absolute', right: 0, top: '110%', zIndex: 101,
                backgroundColor: theme.surface, border: `1px solid ${theme.border}`,
                borderRadius: '8px', boxShadow: theme.shadowMd, padding: '4px',
                minWidth: '160px',
              }}>
                {overflow.map((a) => (
                  <button
                    key={a.key}
                    onClick={(e) => { e.stopPropagation(); setOpenMenu(false); a.onClick && a.onClick(); }}
                    style={{
                      display: 'flex', alignItems: 'center', gap: '8px',
                      width: '100%', padding: '8px 10px', border: 'none', background: 'transparent',
                      cursor: 'pointer', textAlign: 'left',
                      fontSize: '0.84rem', color: theme.navy, borderRadius: '6px',
                    }}
                    onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#f1f5f9'; }}
                    onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}
                  >
                    {a.icon}{a.label}
                  </button>
                ))}
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
}
